import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  "xml:space": "preserve",
  width: "800",
  height: "800",
  viewBox: "0 0 35.668 35.668"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M33.168 5.667H2.5a2.5 2.5 0 1 1 0-5h30.668a2.5 2.5 0 1 1 0 5m-14.501 4.834a2.5 2.5 0 0 0-2.5-2.5H2.5a2.5 2.5 0 1 0 0 5h13.667a2.5 2.5 0 0 0 2.5-2.5m17.001 7.332a2.5 2.5 0 0 0-2.5-2.5H2.5a2.5 2.5 0 1 0 0 5h30.668a2.5 2.5 0 0 0 2.5-2.5m-17.001 7.334a2.5 2.5 0 0 0-2.5-2.5H2.5a2.5 2.5 0 1 0 0 5h13.667a2.5 2.5 0 0 0 2.5-2.5m17.001 7.334a2.5 2.5 0 0 0-2.5-2.5H2.5a2.5 2.5 0 1 0 0 5h30.668a2.5 2.5 0 0 0 2.5-2.5" }, null, -1)
  ]))]))
}
export default { render: render }